export default function TrustSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* About & Stats */}
        <div className="flex flex-col lg:flex-row gap-10 md:gap-16 mb-14 md:mb-20">
          {/* Left: Text */}
          <div className="flex-1">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-4">
              Por que Confiar no<br />
              HoobuySpreadsheet?
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-lg">
              O <strong>hoobuyspreadsheet</strong> e uma ferramenta que organiza produtos selecionados de fornecedores chineses, permitindo que usuarios encontrem itens de alta qualidade a precos reduzidos. Todos os produtos sao testados e verificados manualmente pela nossa equipe.
            </p>
          </div>

          {/* Right: Stats */}
          <div className="flex-1 relative">
            <div className="bg-accent-100/40 rounded-2xl p-8 md:p-10 relative overflow-hidden">
              {/* Decorative bg */}
              <div className="absolute inset-0 bg-gradient-to-br from-accent-200/30 to-primary-100/20 rounded-2xl"></div>
              <div className="relative z-10">
                <div className="grid grid-cols-3 gap-4 md:gap-6 divide-x divide-accent-300/40">
                  <div className="text-center px-2">
                    <div className="font-heading text-3xl md:text-5xl font-bold text-accent-600 mb-1">
                      70<span className="text-accent-500">%</span>
                    </div>
                    <p className="text-foreground-600 text-xs md:text-sm leading-snug">
                      Precos mais<br />baratos
                    </p>
                  </div>
                  <div className="text-center px-2">
                    <div className="font-heading text-3xl md:text-5xl font-bold text-accent-600 mb-1">
                      500<span className="text-accent-500">+</span>
                    </div>
                    <p className="text-foreground-600 text-xs md:text-sm leading-snug">
                      Produtos<br />selecionados
                    </p>
                  </div>
                  <div className="text-center px-2">
                    <div className="font-heading text-3xl md:text-5xl font-bold text-accent-600 mb-1">
                      Semanal
                    </div>
                    <p className="text-foreground-600 text-xs md:text-sm leading-snug">
                      Atualizacoes<br />constantes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Comparison Table */}
        <div className="mb-14 md:mb-20">
          <h3 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 text-center mb-8">
            Comparacao de Metodos de Compra
          </h3>
          <div className="overflow-x-auto rounded-xl border border-background-200/70">
            <table className="w-full text-left">
              <thead>
                <tr className="bg-background-100">
                  <th className="px-4 md:px-6 py-4 text-sm font-semibold text-foreground-800 whitespace-nowrap">Metodo</th>
                  <th className="px-4 md:px-6 py-4 text-sm font-semibold text-foreground-800 whitespace-nowrap">Preco</th>
                  <th className="px-4 md:px-6 py-4 text-sm font-semibold text-foreground-800 whitespace-nowrap">Seguranca</th>
                  <th className="px-4 md:px-6 py-4 text-sm font-semibold text-foreground-800 whitespace-nowrap">Facilidade</th>
                  <th className="px-4 md:px-6 py-4 text-sm font-semibold text-foreground-800 whitespace-nowrap">Recomendado</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-background-200/70">
                <tr className="hover:bg-background-50 transition-colors">
                  <td className="px-4 md:px-6 py-4 text-sm font-semibold text-primary-600 whitespace-nowrap">hoobuyspreadsheet</td>
                  <td className="px-4 md:px-6 py-4 text-sm text-foreground-700 whitespace-nowrap">
                    <span className="inline-flex items-center gap-1 text-accent-600 font-semibold">
                      <i className="ri-star-fill text-xs"></i> Baixo
                    </span>
                  </td>
                  <td className="px-4 md:px-6 py-4 text-sm text-foreground-700 whitespace-nowrap">
                    <span className="inline-flex items-center gap-1 text-primary-600 font-semibold">
                      <i className="ri-star-fill text-xs"></i> Alta
                    </span>
                  </td>
                  <td className="px-4 md:px-6 py-4 text-sm text-foreground-700 whitespace-nowrap">
                    <span className="inline-flex items-center gap-1 text-primary-600 font-semibold">
                      <i className="ri-star-fill text-xs"></i> Facil
                    </span>
                  </td>
                  <td className="px-4 md:px-6 py-4 text-sm whitespace-nowrap">
                    <span className="inline-flex items-center gap-1 px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full">
                      <i className="ri-check-line"></i> Sim
                    </span>
                  </td>
                </tr>
                <tr className="hover:bg-background-50 transition-colors">
                  <td className="px-4 md:px-6 py-4 text-sm text-foreground-700 whitespace-nowrap">AliExpress</td>
                  <td className="px-4 md:px-6 py-4 text-sm text-foreground-600 whitespace-nowrap">Medio</td>
                  <td className="px-4 md:px-6 py-4 text-sm text-foreground-600 whitespace-nowrap">Alta</td>
                  <td className="px-4 md:px-6 py-4 text-sm text-foreground-600 whitespace-nowrap">Muito facil</td>
                  <td className="px-4 md:px-6 py-4 text-sm whitespace-nowrap">
                    <span className="inline-flex items-center gap-1 px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-semibold rounded-full">
                      Medio
                    </span>
                  </td>
                </tr>
                <tr className="hover:bg-background-50 transition-colors">
                  <td className="px-4 md:px-6 py-4 text-sm text-foreground-700 whitespace-nowrap">Compra direta</td>
                  <td className="px-4 md:px-6 py-4 text-sm text-foreground-600 whitespace-nowrap">Baixo</td>
                  <td className="px-4 md:px-6 py-4 text-sm text-foreground-600 whitespace-nowrap">Baixa</td>
                  <td className="px-4 md:px-6 py-4 text-sm text-foreground-600 whitespace-nowrap">Dificil</td>
                  <td className="px-4 md:px-6 py-4 text-sm whitespace-nowrap">
                    <span className="inline-flex items-center gap-1 px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full">
                      Nao recomendado
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* How It Works */}
        <div>
          <h3 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 text-center mb-8">
            Como Funciona
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {[
              { step: '1', icon: 'ri-search-line', title: 'Escolha Produtos', desc: 'Navegue no spreadsheet e encontre os itens que deseja' },
              { step: '2', icon: 'ri-links-line', title: 'Clique no Link', desc: 'Acesse diretamente o fornecedor pelo link no spreadsheet' },
              { step: '3', icon: 'ri-shopping-cart-line', title: 'Compre via Agente', desc: 'Use o agente Hoobuy para processar sua compra' },
              { step: '4', icon: 'ri-home-line', title: 'Receba em Casa', desc: 'Entrega segura diretamente no seu endereco' },
            ].map((item) => (
              <div key={item.step} className="bg-background-100 rounded-xl p-5 md:p-6 text-center group hover:bg-background-200/70 transition-colors duration-200">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-200 transition-colors duration-200">
                  <i className={`${item.icon} text-xl text-primary-600`}></i>
                </div>
                <div className="font-heading text-sm font-bold text-foreground-800 mb-1.5">{item.title}</div>
                <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}